import { render, staticRenderFns } from "./detaliPageBtn.vue?vue&type=template&id=4760cd32&scoped=true"
import script from "./detaliPageBtn.vue?vue&type=script&lang=js"
export * from "./detaliPageBtn.vue?vue&type=script&lang=js"
import style0 from "./detaliPageBtn.vue?vue&type=style&index=0&id=4760cd32&prod&lang=scss&scoped=true"
import style1 from "./detaliPageBtn.vue?vue&type=style&index=1&id=4760cd32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760cd32",
  null
  
)

export default component.exports